(function() {
    'use strict';

    angular
        .module('elogbooks.user.meter-types')
        .config(registerRoutes)
        .config(registerRoutesList)
        .config(registerRoutesAdd)
        .config(registerRoutesDetails)
        .config(registerRoutesEdit);

    function registerRoutes($stateProvider) {
        $stateProvider
            .state('dashboard.user.meters.types', {
                abstract: true,
                template: '<bookerize></bookerize>',
                ncyBreadcrumb: {
                    skip: true
                },
                data: {
                    modules: ['meters']
                }
            });
    }

    function registerRoutesList($stateProvider) {
        $stateProvider
            .state('dashboard.user.meters.types.list', {
                url: '/meter-types?page&limit&order&id&name',
                parent: 'dashboard.user.meters.types',
                views: parseBook({
                    'elogbooks-left@dashboard.user.meters.types': {
                        templateUrl: '/modules/user/meters/meter-types/meter-type-list.html',
                        controller: 'MeterTypesController',
                        controllerAs: 'vm'
                    }
                }),
                params: {
                    page: '1',
                    limit: '30',
                    order: 'id',
                    id: null,
                    name: null
                },
                resolve: {
                    meterTypesCollectionResponse: function($stateParams, apiClient, rootResourceResponse) {
                        $stateParams.type = 'meter_type';

                        return apiClient.get(rootResourceResponse.getLink('metertypes'), $stateParams).then( function(response) {
                            return response || apiClient.noResourceFound();
                        });
                    }
                },
                ncyBreadcrumb: {
                    label: '{{ ::"METER_TYPE_LIST" | translate }}'
                }
            });
    }

    function registerRoutesAdd($stateProvider) {
        $stateProvider
            .state('dashboard.user.meters.types.list.add', {
                url: '/add',
                parent: 'dashboard.user.meters.types.list',
                views: parseBook({
                    'elogbooks-right@dashboard.user.meters.types': {
                        templateUrl: '/modules/user/meters/meter-types/add-edit/meter-type-add-edit.html',
                        controller: 'MeterTypesAddEditController',
                        controllerAs: 'vm'
                    }
                }),
                resolve: {
                    meterTypeResponse: function() {
                        return {
                            type : 'meter'
                        };
                    }
                },
                ncyBreadcrumb: {
                    label: '{{ ::"ADD" | translate }}'
                }
            });
    }

    function registerRoutesDetails($stateProvider) {
        $stateProvider
            .state('dashboard.user.meters.types.list.details', {
                url: '/details/{resource}',
                abstract: true,
                parent: 'dashboard.user.meters.types.list',
                views: parseBook({
                    'elogbooks-right@dashboard.user.meters.types': {
                        templateUrl: '/modules/user/meters/meter-types/details/meter-type-details.html',
                        controller: 'MeterTypesDetailsController',
                        controllerAs: 'vm'
                    }
                }),
                resolve: {
                    meterTypeResponse: function(apiClient, $stateParams) {
                        return apiClient.get($stateParams.resource.decode()).then( function(response) {
                            return response || apiClient.noResourceFound();
                        });
                    }
                },
                ncyBreadcrumb: {
                    label: '{{ ::$resolves().meterTypeResponse.name }}'
                }
            })
             .state('dashboard.user.meters.types.list.details.info', {
                url: '/info',
                parent: 'dashboard.user.meters.types.list.details',
                views: parseBook({
                    'elogbooks-right@dashboard.user.meters.types.list.details': {
                        templateUrl: '/modules/user/meters/meter-types/details/info/meter-type-info.html',
                        controller: 'MeterTypesInfoController',
                        controllerAs: 'vm'
                    }
                }),
                ncyBreadcrumb: {
                    label: '{{ ::"INFO" | translate }}'
                }
            });
    }

    function registerRoutesEdit($stateProvider) {
        $stateProvider
            .state('dashboard.user.meters.types.list.details.info.edit', {
                url: '/edit',
                parent: 'dashboard.user.meters.types.list.details.info',
                views: parseBook({
                    'elogbooks-right@dashboard.user.meters.types': {
                        templateUrl: '/modules/user/meters/meter-types/add-edit/meter-type-add-edit.html',
                        controller: 'MeterTypesAddEditController',
                        controllerAs: 'vm'
                    }
                }),
                ncyBreadcrumb: {
                    label: '{{ ::"EDIT" | translate }}'
                }
            });
    }

})();
